import { useState } from "react";
import DeleteTemplateModal from "../DeleteTemplateModal";
import { useMessagingServiceUrl } from "../../reducers/layoutReducer/selectors";
import { deleteTextTemplate, errorMessage, type TextTemplate } from "./service";

interface DeleteTextTemplateModalProps {
  template?: TextTemplate | null;
  onClose: () => void;
  onDeleted: (template: TextTemplate) => void;
}

const DeleteTextTemplateModal = ({ template = null, onClose, onDeleted }: DeleteTextTemplateModalProps) => {
  const messagingServiceUrl = useMessagingServiceUrl() as string;
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClose = () => {
    setError(null);
    onClose();
  };

  const onDelete = () => {
    if (!template) return;
    setDeleting(true);
    setError(null);
    deleteTextTemplate(messagingServiceUrl, template.uuid)
      .then(() => onDeleted(template))
      .catch((err) => setError(errorMessage(err)))
      .finally(() => setDeleting(false));
  };

  return (
    <DeleteTemplateModal
      show={Boolean(template)}
      onClose={handleClose}
      onConfirm={onDelete}
      loading={deleting}
      error={error}
    >
      <p className="tw-m-0">
        Deleting <strong>{template?.templateName}</strong> cannot be undone.
      </p>
    </DeleteTemplateModal>
  );
};

export default DeleteTextTemplateModal;
